export default "__VITE_ASSET__BNtX_bbi__"